import { BaseService } from "./BaseService";
import { CognitoUser } from "amazon-cognito-identity-js";
import { useConfig } from "../hooks/useConfig";
import KSUID from "react-native-ksuid";
import { v4 as uuidv4 } from "uuid";
const config = useConfig();

export const STATE_MACHINE_CERTIFIED_BANK_ACCOUNT_MACHINE_ID = "certified_bank_account";

export const STATE_MACHINE_CERTIFIED_BANK_ACCOUNT_STATES = Object.freeze({
  PENDING: "PENDING",
  INIT_RESPONDED: "INIT_RESPONDED",
  INIT_FAILED: "INIT_FAILED",
  LINK_FAILED: "LINK_FAILED",
  PMT_SRC_FAILED: "PMT_SRC_FAILED",
  AN_CONFIRMATION: "AN_CONFIRMATION",
  INVALID_RN: "INVALID_RN",
  BLACKLISTED_RN: "BLACKLISTED_RN",
  PREDICTOR_APPROVED: "PREDICTOR_APPROVED",
  PREDICTOR_APPROVED_FDCASH: "PREDICTOR_APPROVED_FDCASH",
  PREDICTOR_DENIED: "PREDICTOR_DENIED",
  PREDICTOR_FAILED: "PREDICTOR_FAILED",
  PAYMENT_CREATED: "PAYMENT_CREATED",
  PAYMENT_FAILED: "PAYMENT_FAILED",
});

export const STATE_MACHINE_CERTIFIED_BANK_ACCOUNT_COMMANDS = Object.freeze({
  START_CERTIFIED_BA: "START_CERTIFIED_BA",
  STORE_ACCOUNT_ID: "STORE_ACCOUNT_ID",
  CLOSE_WIDGET: "CLOSE_WIDGET",
  USER_CONFIRMS_AN: "USER_CONFIRMS_AN",
  USER_CONFIRMS: "USER_CONFIRMS",
});

export class DynamoStreamMachineService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (tokens: any) => {},
    public url = config.dynamoStreamMachineService
  ) {
    super(url, cognitoUser, dispatch);
  }

  async createMachine(machineId: string, command: string, attrs: any) {
    const entityId = uuidv4();
    return this.transitionMachine(
      machineId,
      entityId,
      STATE_MACHINE_CERTIFIED_BANK_ACCOUNT_STATES.PENDING,
      command,
      attrs
    );
  }

  async transitionMachine(
    machineId: string,
    entityId: string,
    currentState: string,
    command: string,
    attrs: any
  ) {
    let PK = this.cognitoUser.getUsername();
    let SK = entityId;

    let body: any = {
      machine_state: currentState,
    };
    if (attrs) {
      attrs.machine_state = body.machine_state;
      body = attrs;
    }

    let endpoint = `${machineId}/${PK}/${SK}/${command}`;
    this.logger.info(
      `Updating state machine ${endpoint} --> Current state: ${currentState}, Command: ${command}, attributes: ${JSON.stringify(
        attrs
      )}`
    );
    let result = await this.makePatchRequest(endpoint, body, true);
    await this.logger.log(JSON.stringify({ result }));
    return result;
  }

  async getMachine(machineId: string, entityId: string) {
    let PK = this.cognitoUser.getUsername();
    let SK = entityId;

    let result = await this.makeGetRequest(`${machineId}/${PK}/${SK}`, true);
    await this.logger.log(JSON.stringify({ result }));
    return result;
  }

  async pollMachineState(
    machineId: string,
    entityId: string,
    states: any[],
    pollingSeconds: number,
    setStateMachine: any
  ) {
    let stateMachine: any = null;
    let timer = 0;
    let interval_second = 1000;
    let intervalId = setInterval(async () => {
      try {
        stateMachine = await this.getMachine(machineId, entityId);
        if (states.includes(stateMachine.item.machine_state)) {
          this.logger.log(
            `State machine state found while polling --> ${stateMachine.item.machine_state}`
          );
          clearInterval(intervalId);
          setStateMachine(stateMachine);
        } else {
          this.logger.log(
            `State machine state NOT found --> Recent polled state: ${stateMachine.item.machine_state} , looking for: ${states}`
          );
        }
      } catch (err) {
        this.logger.log("State machine Error from server");
        clearInterval(intervalId);
      }
      timer += 1;
      this.logger.log(`Polling Timer seconds: ${timer}`);
      if (timer > pollingSeconds) {
        this.logger.log(
          `Polling Timer seconds ${timer} more than ${pollingSeconds}, stopping polling`
        );
        clearInterval(intervalId);
        setStateMachine(stateMachine);
      }
    }, interval_second);
  }
}
